import type {
  IPairing,
  IScenarioViolationEvaluation,
} from "@vmosolutions/oc-interfaces";
import type { AnyAction } from "redux";
import type { ThunkDispatch } from "redux-thunk";
import type { INotifications } from "src/API/AmplifyAPIWrapper";
import AmplifyAPIWrapper from "src/API/AmplifyAPIWrapper";

/**
 * The regulations pre-check ("scenario") result types (`IScenarioViolationEvaluation` / `IScenarioPositionResult`)
 * and the `ScenarioPositionStatus` enum live in oc-interfaces (violations/IScenarioViolations.ts), shared with the
 * backend endpoint. Re-exported here for the panel's convenience.
 */
export type {
  IScenarioPositionResult,
  IScenarioViolationEvaluation,
} from "@vmosolutions/oc-interfaces";
export { ScenarioPositionStatus } from "@vmosolutions/oc-interfaces";

/**
 * Run the regulations pre-check for a (possibly unsaved/draft) pairing. The full pairing is sent so the backend
 * splices the current editor state into each assigned crew member's schedule and returns the NEW violations the
 * assignment would cause (plus an un-crewed self-check for open seats). Held in local component state by the
 * caller; returns null on failure. When `dispatch` is supplied, info/success/error notifications are shown.
 */
export const fetchScenarioViolations = async (
  pairing: IPairing,
  draft: boolean = true,
  dispatch?: ThunkDispatch<object, object, AnyAction>,
): Promise<IScenarioViolationEvaluation | null> => {
  const notifications: INotifications | undefined = dispatch
    ? {
        dispatch: dispatch,
        infoMessage: "Running regulations pre-check...",
        successMessage: "Regulations pre-check complete",
        errorMessage: "Error: Unable to run regulations pre-check",
      }
    : undefined;
  return AmplifyAPIWrapper.Post<IScenarioViolationEvaluation>(
    "/violations/scenario",
    { pairing: pairing, draft: draft },
    notifications,
  );
};
